import { months as arrayMonths, years as arrayYears } from './constants';

export const yearsToReport = () => {
  const currentYear = new Date().getFullYear().toString();
  const originalYears = [...arrayYears];
  return originalYears.filter((year) => year <= currentYear);
};

export const monthsToReport = (selectedYear = '2020') => {
  const originalMonths = [...arrayMonths];
  const currentDate = new Date();
  const currentMonth = currentDate.getMonth();
  const currentYear = currentDate.getFullYear().toString();

  return currentYear === selectedYear
    ? originalMonths.map((month) =>
        month.id <= currentMonth
          ? { ...month, active: true }
          : { ...month, active: false }
      )
    : originalMonths.map((month) => ({ ...month, active: true }));
};
